
<div id="cardview-container" style="display:flex; flex-direction: row;" [ngStyle]="{'height': selectedSet.length>0 ? '100%' : '160px'}"> <!-- 2/25/26 Add asset selector smaller so can see around on phone-->
  <!-- <div style="position: absolute;right: 16px;"> -->
    <!-- dynamic based on open windows -->

  <sms-asset-detail
      id="assetDetailComponent" 
      *ngIf="showAssetDtl==true" 
      style="height:100%"
      [AI]="AI"
      [map]="map"
      [Edit]="Edit"
      [Draw]="Draw"
      [Editor]="Editor"
      [Query]="Query"
      [QueryTask]="QueryTask"
      [Graphic]="Graphic"
      [FeatureLayer]="FeatureLayer"
      [signLayer]="FeatureLayer"
      [webMercatorUtils]="webMercatorUtils"
      [Polygon]="Polygon"
      [geometryEngine]="geometryEngine"
      [featureLayer]="featureLayer"
      [activeAsset]="activeAsset"
      [asset]="asset"
      [geometryJsonUtils]="geometryJsonUtils"
      [isAssetNew]="eeService.addNewParent"
      [isDeleteClicked]="isDeleteClicked"
      [Point]="Point"
      [selectedSet]="selectedSet"
      [ismodelpopup]="false"
      [isVisualizationAsset]="visualizationAssetIsActive"
      [selectedLayerName]="selectedLayerName"
      [currentLayerData]="activeVisualizationRecord"
      [activeFeature]="activeFeature"
      [newChildFeature]="newChildFeature"
      [newChildFClass]="newChildFClass"
      [isVisualizationAsset]="visualizationAssetIsActive"
      (closeAssetDetailCard)="closeAssetDetail()"
      (checkIfNewAsset)="getIfNewAsset()"
      (assetUpdated)="loadSelectedParentFeatureInView()"
    >
  </sms-asset-detail>           <!-- (assetAttributes)="getAssetAttributes()" -->
  <!-- </div> -->
  <!-- <div style="position: absolute;right: 16px;"> -->

  <div id="cardview" style="display:flex; flex-direction:column;" class="cardview-content" cdkDrag cdkDragBoundary="#cardViewDiv" > 

    <div class="avPanel" id="assestDragDiv" style="overflow:hidden; border-radius: none;  height:100%">
      
      <!-- header -->
      <app-configurable-header
        cdkDragHandle
        [headingText]="assetViewerLabel"
        [variant]="'threeIcon'"
        [iconOne]="getRelocateAssetIcon()"
        tooltipOne="{{ 'Select.carddisplay.relocatebtn' | translate }}"
        [iconTwo]="getAssetAddIcon()"
        [tooltipTwo]="getAssetAddTooltip()"
        [iconTwoDropdown]="true"
        [iconThree]="getCloseIcon()"
        [tooltipThree]="'Close'"
        [tableAliases]="tableAliases"
        [signAddAccess]="signAddAccess"
        [lightAddAccess]="lightAddAccess"
        [iconFour]="getMinMaxIcon()"
        [tooltipFour]="isShown == false ? expand : minimize"
        reshapeTooltip="{{ 'Select.carddisplay.reshapebtn' | translate }}"
        (actionFour)="minimizeAssetViewer()"
        (actionThree)="closeAssetViewer()"
        (actionTwo)="(null)"
        (reshape)="reshape()"
        (dropdownAction)="addRelatedAsset($event)"
        (actionOne)="relocateAsset()"
        [isCardView]="true"
      >
        <!-- TSDRSAM-1815 reshape icon was missing -->
        <!-- [iconFive]="getReshapeAssetIcon()"
        (actionFive)="reshape()" -->
      </app-configurable-header>

      <!-- form body / scrollable section -->
      <div id="assestdiv" style="overflow:auto; margin-bottom: 50px;">

        <!-- asset class selector for Selected Set -->
        <div *ngIf="selectedSet.length>0" class="layer-selection">
          <!-- <div *ngIf="!activeVisualizationAsset" class="asset-card-sub-heading h6" style="visibility: hidden">   {{ selectedLayer }}  </div> -->
          <div class="layer-select">
            <mat-form-field class="small" appearance="outline" style="width:200px;">
              <mat-select [(ngModel)]="selectedLayerName">
                <mat-option (onSelectionChange)="layerChangedFromUi($event, i)" [value]="layer.LayerInfo.name" *ngFor="let layer of selectedSet; let i = index">
                  <span *ngIf="!currentUser.scndLang">{{ layer.LayerInfo.alias }}</span><span *ngIf="currentUser.scndLang">{{ layer.LayerInfo.aliasSL }}</span>
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <!-- asset class selector for Add New Asset-->
        <div class="layer-selection" *ngIf="(!selectedSet || selectedSet.length === 0) && selectedLayerName && visibleInventoryLayers.length > 0">
          <div class="layer-select">
            <mat-form-field class="small custom-fill" appearance="outline" style="width:200px;">
              <mat-select [(ngModel)]="selectedLayerName" id="addAssetClass">
                <mat-option (onSelectionChange)="layerChangedFromUi($event, i)" [value]="opt.name" *ngFor="let opt of visibleInventoryLayers; let i = index" name="userlyrtype">
                  <span *ngIf="!currentUser.scndLang">{{ opt.alias }}</span><span *ngIf="currentUser.scndLang">{{ opt.aliasSL }}</span>
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div>


        <!-- asset cards / form body -->
        <!-- <div class="avScrollArea scroll-avPanel"> -->

            <!-- Visualization layer open details button -->
          <div *ngIf="visualizationAssetIsActive" class="avAssetCard avCurrentAsset">
            <div class="avAssetCardContent show hand-pointer" id="assetCard" tabindex="0" (click)="OpenVisualizationAssetDetail()">
              <div class="card-body avRow" style="padding-top: 16px; padding-bottom: 16px">
                <div class="asset-card-sub-heading h6">Visualization Layer Data</div>
              </div>
            </div>
              <div (click)="OpenVisualizationAssetDetail()" style="color: black"></div>
            </div>
          </div>

          <!-- Parent Asset Card -->
          <div *ngIf="!visualizationAssetIsActive">
            <div *ngIf="activeFeature && !eeService.toggleParent"
                [ngClass]="eeService.activeAssetInfo[0].AssetID === activeFeature[0]['AssetID'] ? 'avAssetCard avCurrentAsset' : 'avAssetCard'" >
              <div class="avAssetCardContent show hand-pointer asset-header" id="assetCard" (click)="openAssetDetail('Parent', null, null)">
                <div class="img-container">
                  <img tabindex="0" class="text-center justify-content-center align-self-center" [src]="activeFeature[7]?.ImageBase64" (error)="onPicError($event)" alt="{{ activeFeature[0]['AssetCode'] }}" />
                </div>
                <div class="key-columns">
                  <span class="h7" *ngIf="fieldsInfo.length > 0 && fieldsInfo[0].codedValues">{{ fieldsInfo[0].codedValues[activeFeature[0]["AssetCode"]] }}</span>
                  <span class="h7" *ngIf="fieldsInfo.length > 0 && !fieldsInfo[0].codedValues">{{ activeFeature[0]["AssetCode"] }}</span>
                  <span class="avFormLabel">{{ activeFeature[0]["AssetID"] }}</span>
                  <span *ngIf="openTasks[activeFeature[0]['AssetID']] > 0" class="badge badge-pill badge-warning">{{ openTasks[activeFeature[0]['AssetID']] }}</span>
                </div>
              </div>
            </div>

            <div *ngIf="selectedSet.length>0">
              <div *ngIf="activeFeature && !eeService.toggleParent"
                  [ngClass]="eeService.activeAssetInfo[0].AssetID === activeFeature[0]['AssetID'] ? 'avAssetCard avCurrentAsset' : 'avAssetCard'"
              >
                <div class="avAssetCardContent show hand-pointer" id="assetCard" (click)="openAssetDetail('Parent', null, null)">
                  <div class="card-body avRow">
                    <!-- Parent -->
                    <!-- Added by Abhilash for JIRA ID:-34 on 08/12/2021 -->
                    <div *ngFor="let item of fieldsInfo; let rid = index">

                      <div *ngIf="item.IsCardviewColumnVisible === 1 && item.fieldName === 'DoNotReplace'">
                        <div class="avCardDetailRow">
                          <div class="avFormLabel">{{ item.label }}</div>
                          <div class="avFormValue" *ngIf="activeFeature[0][item.fieldName] == 1 && doNotReplaceDomain[1].code == 1 && doNotReplaceDomain[1].name != null" class="avJustifyRight avFormValue">
                            {{ doNotReplaceDomain[1].name }}
                          </div>
                          <div class="avFormValue" *ngIf="activeFeature[0][item.fieldName] == 0 && doNotReplaceDomain[0].code == 0 && doNotReplaceDomain[0].name != null" class="avJustifyRight avFormValue">
                            {{ doNotReplaceDomain[0].name }}
                          </div>
                        </div>
                      </div>

                      <!-- Apply condition on class  ngif class Mani 11/19/2021-->
                      <div
                        *ngIf="
                          item.fieldName != 'DoNotReplace' &&
                          item.IsCardviewColumnVisible === 1 &&
                          item.fieldName !== 'InstallDate' &&
                          item.fieldName !== 'CollectDate' &&
                          item.fieldName !== 'LastModifyDate' &&
                          item.fieldName !== 'RetireDate'
                        "
                      >
                        <div class="avCardDetailRow">
                          <div>{{ item.label }}</div>
                          <div class="avFormValue">{{ activeFeature[0][item.fieldName] }}</div>
                        </div>
                      </div>

                      <div *ngIf="item.IsCardviewColumnVisible === 1 && (item.fieldName === 'InstallDate' || item.fieldName === 'CollectDate' || item.fieldName === 'LastModifyDate' || item.fieldName === 'RetireDate')">
                        <!-- Apply condition on class  ngif class Mani 11/19/2021-->
                        <div class="avCardDetailRow">
                          <div>{{ item.label }}</div>
                          <div class="avFormValue">{{ activeFeature[0][item.fieldName] | date : "MM/dd/yyyy" }}</div>

                          <!--  8/14/20 jcc -->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              <!-- USE TABLE ALIAS -->
            </div>
          </div> <!-- End parent asset card-->




          <!-- progress spinner -->
          <div *ngIf="loading" class="spinner-border spinner" role="status">
            <span class="sr-only">Loading...</span>
          </div>

          <!-- Child Asset Card -->
          <div class="child-card" *ngIf="showChildCard">
            <div *ngFor="let relatedFeatures of childRelationshipInfo; let rid = index">
              <div
                *ngIf="
                  relatedFeatures.data?.length > 0 &&
                  !relatedFeatures.name.includes('Maintenance') &&
                  !relatedFeatures.name.includes('Assessment') &&
                  !relatedFeatures.name.includes('Documents')
                "
              >
                <!-- Child Asset Class title-->
                <div class="avSectionHeader" *ngIf="relatedFeatures.data && relatedFeatures.data.length > 0 && childLayerAccess(relatedFeatures.layer_id)">
                  <div *ngIf="relatedFeatures.data && relatedFeatures.data.length > 0 && childLayerAccess(relatedFeatures.layer_id)" class="avRow">
                    <div class="h5 child-heading">
                      <!-- {{ relatedFeatures.relationshipName | slice : selectedLayerName.length + 2 : relatedFeatures.relationshipName.length }} -->
                      {{ relatedFeatures.label ? relatedFeatures.label : relatedFeatures.name | slice : selectedLayerName.length + 2 : relatedFeatures.name.length }}
                    </div>
                  </div>
                  <div class="divider"></div>
                </div>

                <!-- Card for each related Sign -->
                <div *ngIf="relatedFeatures.name == 'SupportToSign' && !eeService.toggleSign && childLayerAccess(this.currentUser.tableIds.signId)">
                  <div class="show hand-pointer" id="relAssetCard_{{ relatedFeatures.name }}">
                    <div *ngFor="let relatedFeature of relatedFeatures.data; let rid = index">
                      <div *ngIf="relatedFeature.attributes.Status != 'Inactive'">
                        <!-- 8/6/2020 jcc don't display inactive child assets-->
                        <!--jcc 9/22/20 switch to AssetID because it is possible for a related Sign and Support to have the same ObjectID, in which case both cards were shown as current. -->
                        <div
                          [ngClass]="eeService.activeAssetInfo[0].AssetID === relatedFeature['attributes']['AssetID'] ? 'avAssetCard avCurrentAsset' : 'avAssetCard'"
                          (click)="openAssetDetail('Child', relatedFeature, relatedFeatures)"
                        >
                          <div class="avRow asset-header avAssetCardContent">

                            <!-- asset code icon -->
                            <div class="img-container">
                              <img
                                tabindex="0"
                                class="text-center justify-content-center align-self-center"
                                [src]="relatedFeature?.ImageBase64"
                                (error)="setSignPic($event, relatedFeature)"
                                alt="{{ relatedFeature['attributes']['AssetCode'] }}"
                              />
                            </div>

                            <div class="key-columns">
                              <span class="h7" *ngIf="fieldsInfo.length > 0 && fieldsInfo[0].codedValues">{{ relatedFeature["attributes"]["AssetCode"] }}</span>
                              <span class="avFormLabel">{{ relatedFeature["attributes"]["AssetID"] }}</span>
                              <span *ngIf="openTasks[relatedFeature['attributes']['AssetID']] > 0" class="badge badge-pill badge-warning">
                                {{ openTasks[relatedFeature["attributes"]["AssetID"]] }}
                              </span>
                            </div> 
                          </div>

                          <div class="donot-replace-icon-div" *ngIf="relatedFeature.attributes.DoNotReplace == 1">
                              <img class="donot-replace-icon" src="assets/images/error_icon.png" />
                          </div>

                          <div class="card-body avRow avAssetCardContent">

                            <div class="w-100" *ngFor="let item of fieldsInfoSign; let fid = index">

                              <div *ngIf="item.IsCardviewColumnVisible === 1 && item.fieldName === 'DoNotReplace'">
                                <div class="avCardDetailRow">
                                  <div class="avFormLabel">{{ item.label }}</div>
                                  <div *ngIf="relatedFeature['attributes'][item.fieldName] == 1 && doNotReplaceDomain[1].code == 1" class="avJustifyRight avFormValue">{{ doNotReplaceDomain[1].name }}</div>
                                  <div *ngIf="relatedFeature['attributes'][item.fieldName] == 0 && doNotReplaceDomain[0].code == 0" class="avJustifyRight avFormValue">{{ doNotReplaceDomain[0].name }}</div>
                                </div>
                              </div>

                              <!-- Sign details -->
                              <div *ngIf="item.fieldName != 'DoNotReplace' &&
                                          item.IsCardviewColumnVisible === 1 &&
                                          item.fieldName !== 'InstallDate' &&
                                          item.fieldName !== 'CollectDate' &&
                                          item.fieldName !== 'LastModifyDate' &&
                                          item.fieldName !== 'RetireDate' " >
                                <div class="avCardDetailRow">
                                  <div class="avFormLabel">{{ item.label }}</div>
                                  <div class="avJustifyRight avFormValue">{{ relatedFeature["attributes"][item.fieldName] }}</div>
                                </div>
                              </div>

                              <div *ngIf="item.IsCardviewColumnVisible === 1 && 
                                        (item.fieldName === 'InstallDate' || 
                                         item.fieldName === 'CollectDate' || 
                                         item.fieldName === 'LastModifyDate' || 
                                         item.fieldName === 'RetireDate')" >
                                <div class="avCardDetailRow" >
                                  <div class="avFormLabel">{{ item.label }}</div>
                                  <div class="avJustifyRight avFormValue">{{ relatedFeature["attributes"][item.fieldName] | date : "MM/dd/yyyy" }}</div>
                                </div>
                              </div>

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>


                <!-- Card for each related Light -->
                <div *ngIf="relatedFeatures.name == 'SupportToLight' && !eeService.toggleLight && childLayerAccess(this.currentUser.tableIds.lightId)" class="xavAssetCard">
                  <div class="show hand-pointer" id="relAssetCard_{{ relatedFeatures.name }}">

                    <div *ngFor="let relatedFeature of relatedFeatures.data; let rid = index">
                      <div *ngIf="relatedFeature.attributes.Status != 'Inactive'">
                        <!-- 8/6/2020 jcc don't display inactive child assets-->
                        <!--jcc 9/22/20 switch to AssetID because it is possible for a related Sign and Support to have the same ObjectID, in which case both cards were shown as current. -->
                        <div
                          [ngClass]="eeService.activeAssetInfo[0].AssetID === relatedFeature['attributes']['AssetID'] ? 'avAssetCard avCurrentAsset' : 'avAssetCard'"
                          (click)="openAssetDetail('Child', relatedFeature, relatedFeatures)"
                        >
                          <div class="avRow asset-header avAssetCardContent">
                            <div class="img-container">
                              <img
                                tabindex="0"
                                class="text-center justify-content-center align-self-center"
                                [src]="relatedFeature?.ImageBase64"
                                (error)="setSignPic($event, relatedFeature)"
                                alt="{{ relatedFeature['attributes']['AssetCode'] }}"
                              />
                            </div>
                            <div class="key-columns">
                              <span class="h7">{{ relatedFeature["attributes"]["AssetCode"] }}</span>
                              <span class="avFormLabel">{{ relatedFeature["attributes"]["AssetID"] }}</span>
                              <span *ngIf="openTasks[relatedFeature['attributes']['AssetID']] > 0" class="badge badge-pill badge-warning">
                                {{ openTasks[relatedFeature["attributes"]["AssetID"]] }}
                              </span>

                            </div>
                          </div>

                          <div class="donot-replace-icon-div" *ngIf="relatedFeature.attributes.DoNotReplace == 1">
                            <img class="donot-replace-icon" src="assets/images/error_icon.png" />
                          </div>

                          <!-- Light attributes-->
                          <div class="card-body avRow avAssetCardContent">
                            <div class="w-100" *ngFor="let item of fieldsInfoLight; let rid = index">
                              <div *ngIf="item.IsCardviewColumnVisible === 1 && item.fieldName === 'DoNotReplace'">
                                <div class="avCardDetailRow">
                                  <div class="avFormLabel">{{ item.label }}</div>
                                  <div *ngIf="relatedFeature['attributes'][item.fieldName] == 1 && doNotReplaceDomain[1].code == 1" class="avJustifyRight avFormValue">{{ doNotReplaceDomain[1].name }}</div>
                                  <div *ngIf="relatedFeature['attributes'][item.fieldName] == 0 && doNotReplaceDomain[0].code == 0" class="avJustifyRight avFormValue">{{ doNotReplaceDomain[0].name }}</div>
                                </div>
                              </div>

                              <div
                                *ngIf="
                                  item.fieldName != 'DoNotReplace' &&
                                  item.IsCardviewColumnVisible === 1 &&
                                  item.fieldName !== 'InstallDate' &&
                                  item.fieldName !== 'CollectDate' &&
                                  item.fieldName !== 'LastModifyDate' &&
                                  item.fieldName !== 'RetireDate'
                                "
                              >
                                <div class="avCardDetailRow">
                                  <div class="avFormLabel">{{ item.label }}</div>
                                  <div class="avJustifyRight avFormValue">{{ relatedFeature["attributes"][item.fieldName] }}</div>
                                </div>
                          
                              </div>
                              <div
                                *ngIf="item.IsCardviewColumnVisible === 1 && (item.fieldName === 'InstallDate' || item.fieldName === 'CollectDate' || item.fieldName === 'LastModifyDate' || item.fieldName === 'RetireDate')"
                              >
                                <div class="avCardDetailRow">
                                  <div class="avFormLabel">{{ item.label }}</div>
                                  <div class="avJustifyRight avFormValue">{{ relatedFeature["attributes"][item.fieldName] | date : "MM/dd/yyyy" }}</div>
                                  <!--  8/14/20 jcc -->
                                </div>

                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                
              </div>
            </div>
          </div> <!-- End Child Asset Card -->

        <!-- </div>  End Scroll Area -->

      </div>

    <!-- Navigation Buttons Start -->
    <div class="sms-form-footer" *ngIf="selectedSet.length>0 && !this.eeService.addNewParent && !this.eeService.addNewChild" style="z-index: 201;">
      <button mat-icon-button title="First" style="margin-bottom:5px;" (click)="handlePagination(0)">
        <mat-icon svgIcon="ff-left" style="margin-bottom:5px;"></mat-icon>
      </button>
      <button mat-icon-button title="Previous" style="margin-bottom:5px;" (click)="handlePagination(1)">
        <mat-icon svgIcon="arrow-left" style="margin-bottom:5px;"></mat-icon>
      </button>
      <div class="text-center small" style="margin-top:4px;">{{ visualizationAssetIsActive == true ? currentVisualizationDataIndex + 1 : eeService.selectedFeatureIndex + 1 }} of {{ selectedCount }}</div>
      <button mat-icon-button title="Next" style="margin-bottom:5px;" (click)="handlePagination(2)">
        <mat-icon svgIcon="arrow-right" style="margin-bottom:5px;"></mat-icon>
      </button>
      <button mat-icon-button title="Last" style="margin-bottom:5px;" (click)="handlePagination(3)">
        <mat-icon svgIcon="ff-right" style="margin-bottom:5px;"></mat-icon>
      </button>
    </div>


    </div>


  </div>

</div> 